import { SpinnerIosRegular } from '@fluentui/react-icons'

export const LoadingComponent = ({ text = 'Loading page...', icon }: { text?: string; icon?: React.ReactNode }) => (
  <div className="flex size-full items-center justify-center bg-background">
    <div className="flex flex-col items-center gap-y-10">
      {icon && <div className="text-muted-foreground">{icon}</div>}
      <div className="flex w-max items-center gap-x-2">
        <SpinnerIosRegular fontSize={20} className="animate-spin" />
        <span>{text}</span>
      </div>
    </div>
  </div>
)
